import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UserLayout from '@components/layout/UserLayout.tsx';
import RequisitionProcess from '@features/client/requisitions/RequisitionProcess.tsx';
import { PermissionTypesEnum } from '@mock/Permissions.ts';

const processSearchSchema = z.object({
  ids: z.array(z.coerce.number()).optional().default([]),
});

export const Route = createFileRoute('/c/$orgId/$portalId/requisitions/process/')({
  validateSearch: search => processSearchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  const { ids } = Route.useSearch();

  return (
    <UserLayout oneOfPermission={[PermissionTypesEnum.CLIENT_REQUISITION_PROCESS]}>
      <div className="max-w-[1200px] mx-auto">
        <RequisitionProcess requisitionIds={ids} />
      </div>
    </UserLayout>
  );
}
